/* RONCADOR: FAVORITOS (igual a Fashion Nova)
   - coracao no cabecalho, do lado do carrinho, com a bolinha vermelha da
     quantidade; ao tocar sobe a lista dos favoritos;
   - na pagina de produto o coracao abre "SELECIONE UM TAMANHO": a pessoa
     escolhe o tamanho e toca em Salvar; o coracao do produto fica vermelho;
   - fica salvo NESTE aparelho (ate 40 produtos), sem precisar de conta.
   Outros arquivos usam: window.rcFav.tem(handle), .abrirSalvar(dados),
   .remover(handle) e o aviso "rc:favoritos" quando a lista muda. */
(function () {
  if (window.rcFav) return;
  var CHAVE = 'rcFavoritosV2';
  var MAX = 40;

  function ler() {
    try {
      var l = JSON.parse(localStorage.getItem(CHAVE) || '[]');
      return Array.isArray(l) ? l : [];
    } catch (e) {
      return [];
    }
  }
  function gravar(l) {
    try {
      localStorage.setItem(CHAVE, JSON.stringify(l.slice(0, MAX)));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('rc:favoritos'));
    contador();
  }
  function tem(h) {
    return ler().some(function (x) {
      return x.h === h;
    });
  }
  function remover(h) {
    gravar(
      ler().filter(function (x) {
        return x.h !== h;
      })
    );
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function dinheiro(c) {
    return 'R$ ' + (c / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  var CORACAO =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z"/></svg>';
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m7 12.5 3.2 3.2L17 9"/></svg>';

  /* ---------- coracao do cabecalho ---------- */
  function contador() {
    var n = ler().length;
    document.querySelectorAll('[data-rc-fav-qtd]').forEach(function (b) {
      b.textContent = n > 9 ? '9+' : String(n);
      b.hidden = n === 0;
    });
  }
  function porNoCabecalho() {
    var carrinho = document.getElementById('cart-icon-bubble');
    if (!carrinho || document.querySelector('[data-rc-fav-topo]')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rc-fav-topo';
    b.setAttribute('data-rc-fav-topo', '');
    b.setAttribute('aria-label', 'Meus favoritos');
    b.innerHTML = CORACAO + '<span class="rc-fav-topo__qtd" data-rc-fav-qtd hidden>0</span>';
    carrinho.parentNode.insertBefore(b, carrinho);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      abrirLista();
    });
    contador();
  }

  /* ---------- a folha de baixo (uma so, muda o conteudo) ---------- */
  var folha = null;
  var fechando = null;
  function montar() {
    if (folha && document.body.contains(folha)) return folha;
    folha = document.createElement('div');
    folha.className = 'rc-fav';
    folha.hidden = true;
    folha.innerHTML =
      '<div class="rc-fav__veu" data-rc-fav-fecha></div>' +
      '<div class="rc-fav__caixa" role="dialog" aria-modal="true" aria-labelledby="rcFavTitulo">' +
      '<div class="rc-fav__topo"><p class="rc-fav__titulo" id="rcFavTitulo"></p>' +
      '<button type="button" class="rc-fav__x" data-rc-fav-fecha aria-label="Fechar">' + X + '</button></div>' +
      '<div class="rc-fav__corpo" data-rc-fav-corpo></div>' +
      '<div class="rc-fav__pe" data-rc-fav-pe></div></div>';
    document.body.appendChild(folha);
    folha.addEventListener('click', function (e) {
      if (e.target.closest('[data-rc-fav-fecha]')) fechar();
    });
    return folha;
  }
  function abrir(titulo) {
    montar();
    clearTimeout(fechando);
    folha.querySelector('.rc-fav__titulo').textContent = titulo;
    folha.hidden = false;
    document.documentElement.classList.add('rc-fav-aberta');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        folha.classList.add('is-aberta');
      });
    });
  }
  function fechar() {
    if (!folha || folha.hidden) return;
    folha.classList.remove('is-aberta');
    document.documentElement.classList.remove('rc-fav-aberta');
    fechando = setTimeout(function () {
      folha.hidden = true;
    }, 380);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fechar();
  });

  function cartaoLista(n) {
    return (
      '<div class="rc-fav__lista">' +
      '<div><p class="rc-fav__lista-nome">Meus favoritos</p><p class="rc-fav__lista-qtd">' +
      n + (n === 1 ? ' produto' : ' produtos') + '</p></div>' +
      '<span class="rc-fav__check">' + CHECK + '</span></div>'
    );
  }
  function cartaoAviso() {
    return (
      '<div class="rc-fav__aviso"><div class="rc-fav__aviso-cab">' +
      '<span class="rc-fav__aviso-icone">' + CORACAO + '</span>' +
      '<p class="rc-fav__aviso-tit">Comece a salvar seus favoritos!</p></div>' +
      '<p class="rc-fav__aviso-txt">Salve até <b>' + MAX + ' produtos</b>. Eles ficam guardados neste aparelho, ' +
      'mesmo se você fechar a loja, e é só tocar no coração lá em cima para ver.</p></div>'
    );
  }

  /* ---------- SELECIONE UM TAMANHO (pagina de produto) ---------- */
  function abrirSalvar(d) {
    montar();
    var escolhido = d.tamanhoAtual || null;
    var corpo = folha.querySelector('[data-rc-fav-corpo]');
    var promo = d.de && d.de > d.preco;
    var h =
      '<div class="rc-fav__produto">' +
      (d.foto ? '<img src="' + esc(d.foto) + '" alt="" width="44" height="66">' : '') +
      '<div><p class="rc-fav__produto-nome">' + esc(d.titulo) + '</p>' +
      '<p class="rc-fav__produto-preco"><span class="' + (promo ? 'is-promo' : '') + '">' + dinheiro(d.preco) + '</span>' +
      (promo ? '<s>' + dinheiro(d.de) + '</s>' : '') + '</p></div></div>';
    if (d.tamanhos && d.tamanhos.length) {
      h += '<p class="rc-fav__rot" data-rc-fav-rot>Adicionar à lista</p><div class="rc-fav__tams">';
      d.tamanhos.forEach(function (t) {
        h +=
          '<button type="button" class="rc-fav__tam' + (t.valor === escolhido ? ' is-on' : '') + (t.disponivel ? '' : ' is-off') +
          '" data-valor="' + esc(t.valor) + '">' + esc(t.valor) + '</button>';
      });
      h += '</div>';
    }
    h += cartaoLista(ler().length) + cartaoAviso();
    corpo.innerHTML = h;
    var pe = folha.querySelector('[data-rc-fav-pe]');
    pe.innerHTML = '<button type="button" class="rc-fav__salvar" data-rc-fav-salvar>Salvar</button>';
    corpo.onclick = function (e) {
      var b = e.target.closest('.rc-fav__tam');
      if (!b) return;
      escolhido = b.getAttribute('data-valor');
      corpo.querySelectorAll('.rc-fav__tam').forEach(function (x) {
        x.classList.toggle('is-on', x === b);
      });
      var r = corpo.querySelector('[data-rc-fav-rot]');
      if (r) r.classList.remove('is-alerta');
    };
    pe.querySelector('[data-rc-fav-salvar]').onclick = function () {
      if (d.tamanhos && d.tamanhos.length && !escolhido) {
        var r = corpo.querySelector('[data-rc-fav-rot]');
        if (r) {
          r.classList.remove('is-alerta');
          void r.offsetWidth;
          r.classList.add('is-alerta');
          r.textContent = 'Escolha um tamanho';
        }
        return;
      }
      var l = ler().filter(function (x) {
        return x.h !== d.handle;
      });
      l.unshift({ h: d.handle, t: d.titulo, u: d.url, f: d.foto, p: d.preco, d: d.de || 0, s: escolhido || '' });
      gravar(l);
      fechar();
      if (d.aoSalvar) d.aoSalvar();
    };
    abrir('Selecione um tamanho');
  }

  /* ---------- MEUS FAVORITOS (coracao do cabecalho) ---------- */
  function abrirLista() {
    montar();
    var corpo = folha.querySelector('[data-rc-fav-corpo]');
    var pe = folha.querySelector('[data-rc-fav-pe]');
    corpo.onclick = null;
    function desenhar() {
      var l = ler();
      if (!l.length) {
        corpo.innerHTML =
          '<div class="rc-fav__vazio"><span class="rc-fav__vazio-icone">' + CORACAO + '</span>' +
          '<p class="rc-fav__vazio-tit">Você ainda não tem favoritos</p>' +
          '<p class="rc-fav__vazio-txt">Toque no coração da página do produto para guardar aqui o que você gostou.</p></div>';
        pe.innerHTML = '<button type="button" class="rc-fav__salvar" data-rc-fav-fecha>Continuar comprando</button>';
        return;
      }
      var h = cartaoLista(l.length) + '<ul class="rc-fav__itens">';
      l.forEach(function (x) {
        var promo = x.d && x.d > x.p;
        h +=
          '<li class="rc-fav__item">' +
          '<a href="' + esc(x.u) + '" class="rc-fav__item-foto">' + (x.f ? '<img src="' + esc(x.f) + '" alt="" loading="lazy" width="72" height="108">' : '') + '</a>' +
          '<div class="rc-fav__item-info"><a href="' + esc(x.u) + '" class="rc-fav__item-nome">' + esc(x.t) + '</a>' +
          '<p class="rc-fav__produto-preco"><span class="' + (promo ? 'is-promo' : '') + '">' + dinheiro(x.p) + '</span>' +
          (promo ? '<s>' + dinheiro(x.d) + '</s>' : '') + '</p>' +
          (x.s ? '<p class="rc-fav__item-tam">Tamanho: ' + esc(x.s) + '</p>' : '') +
          '<a href="' + esc(x.u) + '" class="rc-fav__item-ver">Ver produto</a></div>' +
          '<button type="button" class="rc-fav__item-tirar" data-rc-fav-tirar="' + esc(x.h) + '" aria-label="Tirar dos favoritos">' + CORACAO + '</button>' +
          '</li>';
      });
      corpo.innerHTML = h + '</ul>';
      pe.innerHTML = '';
    }
    corpo.onclick = function (e) {
      var b = e.target.closest('[data-rc-fav-tirar]');
      if (!b) return;
      remover(b.getAttribute('data-rc-fav-tirar'));
      desenhar();
    };
    desenhar();
    abrir('Meus favoritos');
  }

  function salvar(x) {
    var l = ler().filter(function (y) {
      return y.h !== x.h;
    });
    l.unshift(x);
    gravar(l);
  }
  window.rcFav = { tem: tem, remover: remover, salvar: salvar, abrirSalvar: abrirSalvar, abrirLista: abrirLista, lista: ler };

  /* ---------- carrinho: lixeira e "Salvar para depois" ----------
     Os dois so apertam o botao "Remover" do proprio tema (que continua
     no carrinho, escondido): tirar do carrinho segue igual ao de antes. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rc-lixo], [data-rc-depois]');
    if (!b) return;
    var linha = b.closest('.cart-item');
    var remover = linha && linha.querySelector('.cart-remove-button');
    if (!remover) return;
    e.preventDefault();
    if (b.hasAttribute('data-rc-depois')) {
      salvar({
        h: b.getAttribute('data-handle'),
        t: b.getAttribute('data-titulo'),
        u: b.getAttribute('data-url'),
        f: b.getAttribute('data-foto'),
        p: parseInt(b.getAttribute('data-preco'), 10) || 0,
        d: parseInt(b.getAttribute('data-de'), 10) || 0,
        s: b.getAttribute('data-tamanho') || ''
      });
    }
    remover.click();
  });

  function iniciar() {
    porNoCabecalho();
    contador();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  /* troca de pagina sem recarregar: confere se o coracao ainda esta la */
  document.addEventListener('rc:pagina-trocada', function () {
    fechar();
    iniciar();
  });
  window.addEventListener('storage', function (e) {
    if (e.key === CHAVE) contador();
  });
})();
